import { render, staticRenderFns } from "./ScreensaverForm.vue?vue&type=template&id=5e3decc0"
import script from "./ScreensaverForm.vue?vue&type=script&lang=ts"
export * from "./ScreensaverForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports